import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import LanguageSelector from '~/components/organisms/language-selector/LanguageSelector';
import { Button } from '~/components/ui/button';
import { PATH } from '~/constants/route-path';
import { COLORS } from '~/styles/colors';

import { StyledActionsWrapper } from './styled';

export default function HeaderPublicActions() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleSignUp = () => {
    navigate(PATH.SIGN_UP);
  };

  const handleLogin = () => {
    navigate(PATH.LOGIN);
  };

  return (
    <StyledActionsWrapper>
      <LanguageSelector />
      <Button
        backgroundColor={COLORS.blue50}
        hoverBackgroundColor={COLORS.blue75}
        color={COLORS.primary}
        size="small"
        onClick={handleLogin}
      >
        {t('buttons:login')}
      </Button>
      <Button
        backgroundColor={COLORS.primary}
        hoverBackgroundColor={COLORS.blue600}
        size="small"
        onClick={handleSignUp}
      >
        {t('buttons:signUp')}
      </Button>
    </StyledActionsWrapper>
  );
}
